import { ItemSource } from '../models/product/source-section.model';
export interface AddCartItemInput extends ItemSource {
  product_variant_id: string;
  quantity: number;
}

export interface UpdateCartItemInput {
  product_variant_id: string;
  quantity: number;
}

export interface Coupon {
  coupon: string;
}
export interface AddCartBulkInput extends ItemSource {
  product_variant_ids: string[];
}

